module.exports = __webpack_public_path__ + "assets/images/default-userpic-75-39b79c72bfbc838f1bd6bfcaa5d9074b.png";